import React from 'react';
import { StyleSheet, TouchableOpacity, Text, StyleProp, ViewStyle, ActivityIndicator, View } from 'react-native';

import screenStyle from '../styles/screen.style';
import colorStyle from '../styles/color.style';

type MyProps = {
  disabled?: boolean;
  onPress: Function;
  style?: StyleProp<ViewStyle>;
  title: string;
  value?: any;
  loading?: boolean;
}

export default class Button extends React.Component<MyProps> {

  _onPress = () => {
    this.props.onPress(this.props.value);
  }

  render() {
    return (
      <TouchableOpacity
        style={[styles.btn, this.props.style, this.props.disabled && styles.errorBtn]}
        onPress={this._onPress}
        disabled={this.props.disabled || this.props.loading}
      >
        <View style={styles.row}>
          {this.props.loading && <ActivityIndicator size="small" style={styles.loader} />}
          <Text style={styles.text} >
            {this.props.title}
          </Text>
        </View>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  btn: {
    alignItems: 'center',
    width: '100%',
    marginBottom: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: 'white',
    borderRadius: 999,
  },
  errorBtn: {
    opacity: 0.45
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loader: {
    marginRight: 8
  },
  text: {
    color: 'black',
    fontSize: 16,
    fontWeight: '600',
    ...screenStyle.bigFontSize
  }
})
